(function () {
    'use strict';

    angular
        .module('app.advertisersManagement')
        .factory('advertisersManagementService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getAdvertisersOfAgency(params, loader) {
                    var url_getAdvertisersOfAgency = $rootScope.apiUrl + 'company/getAdvertisersOfAgency';
                    return handleRequest(url_getAdvertisersOfAgency, 'POST', params, loader);
                }

                function getListAdvertisersOfAgency(params, loader) {
                    var url_getListAdvertisersOfAgency = $rootScope.apiUrl + 'company/getListAdvertisersOfAgency';
                    return handleRequest(url_getListAdvertisersOfAgency, 'POST', params, loader);
                }

                function getAdvertiser(advertiserId, loader) {
                    var url = $rootScope.apiUrl + 'company/' + advertiserId;
                    return handleRequest(url, 'GET', null, loader);
                }

                service.getAdvertisersOfAgency = getAdvertisersOfAgency;
                service.getListAdvertisersOfAgency = getListAdvertisersOfAgency;
                service.getAdvertiser = getAdvertiser;

                return service;
            }
        ]);
})();
